import { apiClient } from '../../services/api';

const state = () => ({
  telas_descanso: null,
  tela_descanso_ativa: null,

});

const getters = {
  getTelasDescanso: state => {
    return state.telas_descanso;
  },
  getTelaDescansoAtiva: state => {
    return state.tela_descanso_ativa
  },
};

const actions = {
  async getTelasDescansos({ commit }, payload) {
    const { cod_producao } = payload;
    try {
      const { data } = await apiClient.get(
        `listarTelaDescansoProducao/${cod_producao}`
      );
      commit('setTelasDescanso', data.tela_descanso);
    } catch (error) {
      return error;
    }
  },
  async getTelaDescansoAtiva({ commit }, payload) {
    const { cod_producao } = payload;
    try {
      const { data } = await apiClient.get(
        `listarTelaDescansoProducaoAtiva/${cod_producao}`
      );

      if (data.tela_descanso.length > 0) {
        commit('setTelasDescansoAtiva', data.tela_descanso[0]);
        localStorage.setItem("@socialcam/tela_descanso_ativa", JSON.stringify(data.tela_descanso[0]))
      } else {
        commit('setTelasDescansoAtiva', null);
        localStorage.setItem("@socialcam/tela_descanso_ativa", null)
      }
    } catch (error) {
      return error;
    }
  }
}

const mutations = {
  setTelasDescanso(state, payload) {
    state.telas_descanso = payload;
  },
  setTelasDescansoAtiva(state, payload) {
    state.tela_descanso_ativa = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};